import React, { createContext, useContext, useEffect, useState} from "react";

const UserContext = createContext({});

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem("user")?localStorage.getItem("user"):'anything')
  useEffect(()=>{
    localStorage.setItem("user",user)
  },[user])
  return (
    <UserContext.Provider value={{user, setUser}}>
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => useContext(UserContext);